<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 48.434 18.475">
    <g id="Sedan" transform="translate(0)">
      <path id="Path_86889" data-name="Path 86889"
        d="M2102.319,74.327a4.027,4.027,0,1,0-4.028-4.027,4.031,4.031,0,0,0,4.028,4.027m0-6.232a2.2,2.2,0,1,1-2.206,2.205,2.208,2.208,0,0,1,2.206-2.205"
        transform="translate(-2061.222 -55.852)" :fill="themeColor" />
      <path id="Path_86890" data-name="Path 86890"
        d="M2290.513,74.327a4.027,4.027,0,1,0-4.027-4.027,4.031,4.031,0,0,0,4.027,4.027m0-6.232a2.2,2.2,0,1,1-2.2,2.205,2.208,2.208,0,0,1,2.2-2.205"
        transform="translate(-2279.01 -55.852)" :fill="themeColor" />
      <path id="Path_86891" data-name="Path 86891"
        d="M2080.989,15.146h1.6a.911.911,0,0,0,0-1.822h-1.6c-.675,0-1.447-.925-1.89-2.232l1.375-4.752,4.055-.512a.909.909,0,0,0,.514-.244l3.5-3.331c1.864-.207,12.063-1.215,16.653.854a.888.888,0,0,0,.1.039,49.144,49.144,0,0,1,6.086,2.718c.977.488,1.821.908,2.456,1.187a20.573,20.573,0,0,0,3.47.95,15.477,15.477,0,0,1,4.53,1.417c1.04.731,1.791,3.425,2.021,4.951a.911.911,0,0,0,1.8-.269c-.072-.483-.761-4.757-2.775-6.173a15.881,15.881,0,0,0-5.188-1.707,19.734,19.734,0,0,1-3.127-.838c-.594-.261-1.42-.673-2.376-1.149a50.873,50.873,0,0,0-6.3-2.81c-5.525-2.45-17.369-1.008-17.872-.945a.915.915,0,0,0-.515.244L2084,4.058l-4.352.549a.912.912,0,0,0-.761.651l-1.618,5.592a.917.917,0,0,0,0,.511c.69,2.334,2.113,3.785,3.715,3.785"
        transform="translate(-2077.236 0)" :fill="themeColor" />
      <path id="Path_86892" data-name="Path 86892"
        d="M2159,86.556h17.086a.911.911,0,1,0,0-1.822H2159a.911.911,0,1,0,0,1.822"
        transform="translate(-2141.278 -71.41)" :fill="themeColor" />
      <path id="Path_86893" data-name="Path 86893"
        d="M2159.846,38.022a.911.911,0,0,0,0-1.822l-24.207-.116h0a.911.911,0,0,0,0,1.822l24.207.116Z"
        transform="translate(-2121.363 -30.41)" :fill="themeColor" />
    </g>
  </svg>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
